// Français pour les titres de page (PAGES[].title) — la barre latérale et la barre supérieure les enveloppent avec t().
import { registerFr } from '../i18n/index.js';

registerFr({
  'Dashboard': 'Dashboard',
  'Clients': 'Clients',
  'Lifecycle': 'Cycle de vie',
  'Documents': 'Documents',
  'Register': 'Registre',
  'Agent': 'Agent',
  'Decks': 'Decks',
  'Contracting': 'Contractualisation',
  'Acceptance': 'Acceptation',
  'Client Portal': 'Portail client',
  'Admin': 'Admin',
}, 'registry');
